import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { SEO, pageSEO } from '../components/SEO';
import { Card, CardContent } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { CheckCircle2, MapPin, Briefcase, GraduationCap, Users, TrendingUp, Award, Upload, Building2, Sparkles, Heart } from 'lucide-react';
import { sendViaWeb3Forms } from '../services/web3formsService';
import { saveSubmission, type FormateurSubmission } from '../services/databaseService';
export function FormateursPage() {
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    const formData = new FormData(e.target as HTMLFormElement);
    const data = Object.fromEntries(formData.entries()) as Record<string, string>;
    // Sauvegarder dans la base de données locale
    saveSubmission<FormateurSubmission>({
      type: 'formateur',
      nom: data.nom || '',
      prenom: data.prenom || '',
      email: data.email || '',
      telephone: data.telephone || '',
      domaine: data.domaine || '',
      experience: data.experience || '',
      disponibilite: data.disponibilite || ''
    });
    // Envoyer via Web3Forms (email à contact@adcc.africa)
    const result = await sendViaWeb3Forms({
      type: 'formateur',
      fields: data
    });
    console.log('📋 Formateur submission result:', result);
    setIsLoading(false);
    setSubmitted(true);
    window.scrollTo(0, 0);
  };
  // --- 9. CONFIRMATION ---
  if (submitted) {
    return <Layout data-id="element-929" data-mp="3nm7gskfywg9n">
        <div className="min-h-[60vh] flex items-center justify-center bg-gray-50 px-4 py-12" data-id="element-930" data-mp="3jn6x6zpo19ll">
          <Card className="max-w-md w-full text-center p-10 shadow-lg border-t-4 border-t-[#1E88E5]" data-id="element-931" data-mp="12y1fvrdg6tfk">
            <div className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-932" data-mp="ywzp7yxljpp7">
              <CheckCircle2 className="w-10 h-10 text-green-600" data-id="element-933" data-mp="3rrpyq7sdbfj5" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-934" data-mp="kn5lasyyz6a">
              Candidature envoyée !
            </h2>
            <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-935" data-mp="5jqbsykorbfu">
              Merci pour votre intérêt. Notre équipe pédagogique va étudier
              votre profil et vous recontactera très prochainement pour un
              premier échange.
            </p>
            <Button onClick={() => window.location.reload()} className="w-full text-lg py-6" data-id="element-936" data-mp="38yvqdwp92lnw">
              Fermer
            </Button>
          </Card>
        </div>
      </Layout>;
  }
  return <Layout data-id="element-937" data-mp="3msd7laugrmar">
      <SEO {...pageSEO.formateurs} data-id="element-938" data-mp="3mswtf2n8iuu2" />

      {/* BLOC 1 — HERO */}
      <section className="bg-[#2C3E50] text-white py-20 md:py-28" data-id="element-939" data-mp="2qah2vje55pru">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-940" data-mp="2q84hsxd36zak">
          <span className="inline-block bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-1 text-sm font-medium text-blue-200 mb-6" data-id="element-941" data-mp="2ua9clzf9u1ys">
            Rejoindre l'équipe pédagogique
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight" data-id="element-942" data-mp="2hr3w3y2rtvpy">
            Devenez Formateur ADCC
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-943" data-mp="28t1r77fx2ixe">
            Partagez votre expertise, formez la prochaine génération de
            professionnels et contribuez à l'insertion digne au Bénin.
          </p>
          <div className="flex justify-center" data-id="element-944" data-mp="1z0m6w3h5di9c">
            <Button size="lg" className="text-lg px-8 py-6 shadow-lg hover:scale-105 transition-transform" onClick={() => {
            document.getElementById('postuler')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-945" data-mp="1u2uhph7w0a8u">
              Postuler maintenant
            </Button>
          </div>
        </div>
      </section>

      {/* BLOC 2 — DOMAINES D'EXPERTISE */}
      <section className="py-20 bg-white" data-id="element-946" data-mp="3l579nm2xuc5p">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-947" data-mp="3l45mij8ndz7m">
          <div className="text-center mb-16" data-id="element-948" data-mp="36gkimn3y7vyn">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-949" data-mp="36frl8cqvqit6">
              Domaines d'expertise recherchés
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-950" data-mp="2xfmcnz9y9edf">
              Vous êtes professionnel·le expérimenté·e et souhaitez transmettre
              vos compétences ?
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-951" data-mp="2nhoqrifkbtnz">
            {[{
            icon: Building2,
            title: 'Hôtellerie & Restauration'
          }, {
            icon: Sparkles,
            title: 'Nettoyage & Hygiène'
          }, {
            icon: Heart,
            title: 'Services à la personne'
          }, {
            icon: Briefcase,
            title: 'Insertion professionnelle'
          }, {
            icon: GraduationCap,
            title: "Formation d'adultes"
          }, {
            icon: Users,
            title: 'Métiers du care'
          }].map((domain, index) => <Card key={index} className="border-none shadow-md hover:shadow-xl transition-all duration-300 group" data-id="element-952" data-mp="2twvzecadd7wd" data-mpi={index}>
                <CardContent className="p-8 text-center" data-id="element-953" data-mp="2p0yk89aue7l6">
                  <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-954" data-mp="33ujr0tcohzab">
                    <domain.icon className="w-8 h-8 text-[#1E88E5]" data-id="element-955" data-mp="19h23h6c9x2fa" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-956" data-mp="14ja9m6s2j68g">
                    {domain.title}
                  </h3>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      {/* BLOC 3 — AVANTAGES */}
      <section className="py-20 bg-gray-50" data-id="element-957" data-mp="1yab0vh1f4d44">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-958" data-mp="237b4llasp3s2">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-959" data-mp="286nukewyqqyv">
            <div data-id="element-960" data-mp="284kwr8pkjtjl">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-961" data-mp="2d5qr1ayvnov8">
                Ce que vous gagnez
              </h2>
              <p className="text-xl text-gray-600 mb-10" data-id="element-962" data-mp="2h6alu7vzage7">
                Rejoindre l'ADCC, c'est bien plus qu'une mission ponctuelle.
              </p>

              <div className="space-y-6" data-id="element-963" data-mp="2m0ev4xspv0ig">
                {[{
                icon: Award,
                title: 'Formation gratuite',
                desc: "Bénéficiez d'une formation de formateur certifiante sans frais."
              }, {
                icon: Briefcase,
                title: 'Missions rémunérées',
                desc: 'Accédez à des opportunités de missions rémunérées régulières.'
              }, {
                icon: TrendingUp,
                title: 'Revenus complémentaires',
                desc: 'Valorisez votre expertise pour générer un revenu additionnel.'
              }, {
                icon: Heart,
                title: 'Impact social',
                desc: "Contribuez concrètement à l'insertion professionnelle au Bénin."
              }, {
                icon: Users,
                title: 'Réseau professionnel',
                desc: "Intégrez une communauté d'experts et de partenaires engagés."
              }].map((benefit, index) => <div key={index} className="flex items-start gap-4" data-id="element-964" data-mp="1qqtfdy4m5d4x" data-mpi={index}>
                    <div className="w-12 h-12 bg-white rounded-xl shadow-sm flex items-center justify-center flex-shrink-0" data-id="element-965" data-mp="1lwp8fevcl53u">
                      <benefit.icon className="w-6 h-6 text-[#1E88E5]" data-id="element-966" data-mp="u8uio6bp5l2a" />
                    </div>
                    <div data-id="element-967" data-mp="z38iqm1b0gda">
                      <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-968" data-mp="laiv6d64n3e2">
                        {benefit.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed" data-id="element-969" data-mp="q9lnqy4x7h55">
                        {benefit.desc}
                      </p>
                    </div>
                  </div>)}
              </div>
            </div>

            <div className="relative" data-id="element-970" data-mp="140h2gr23osgn">
              <div className="absolute inset-0 bg-gradient-to-tr from-[#1E88E5]/20 to-transparent rounded-3xl transform translate-x-6 translate-y-6" data-id="element-971" data-mp="13zfejlzzkbhi"></div>
              <img src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&q=80&w=800" alt="Formateur ADCC en action" className="relative rounded-3xl shadow-2xl w-full object-cover h-[600px]" data-id="element-972" data-mp="191efkp896wba" />
            </div>
          </div>
        </div>
      </section>

      {/* BLOC 4 — PRÉREQUIS */}
      <section className="py-20 bg-white" data-id="element-973" data-mp="3h6x7xauasfka">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-974" data-mp="3v7hqc5waw9d9">
          <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-975" data-mp="3q7vcpvck8r3x">Prérequis</h2>
          <p className="text-xl text-gray-600 mb-12" data-id="element-976" data-mp="3q5sc6hds7fky">
            Pour garantir la qualité de nos formations, nous recherchons des
            profils répondant à ces critères :
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left" data-id="element-977" data-mp="2yijsget97vbv">
            {["Minimum 3 ans d'expérience pratique dans votre domaine d'expertise.", 'Excellentes capacités de communication et sens de la pédagogie.', "Adhésion aux valeurs de l'ADCC (dignité, respect, bienveillance).", 'Disponibilité ponctuelle demandée selon les sessions de formation.'].map((req, index) => <div key={index} className="flex items-start gap-4 bg-gray-50 p-6 rounded-xl" data-id="element-978" data-mp="rf3y88vxahcm" data-mpi={index}>
                <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-979" data-mp="mdofinh7wmxe" />
                <p className="text-gray-700 font-medium" data-id="element-980" data-mp="hf3gushm6bb2">{req}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* BLOC 5 — FORMULAIRE */}
      <section id="postuler" className="py-20 bg-gray-50" data-id="element-981" data-mp="8h1fucxvrins">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-982" data-mp="3p9mjuncayty">
          <Card className="shadow-xl border-t-4 border-t-[#1E88E5]" data-id="element-983" data-mp="3nyng84uaf96">
            <CardContent className="p-8 md:p-12" data-id="element-984" data-mp="3uwm7mkrcfwf5">
              <div className="text-center mb-10" data-id="element-985" data-mp="3ut87zka2e1be">
                <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-986" data-mp="3pxstcq48g1dx">
                  Postuler maintenant
                </h2>
                <p className="text-gray-600" data-id="element-987" data-mp="3lwz51vmvokki">
                  Remplissez ce formulaire pour rejoindre notre vivier de
                  formateurs.
                </p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-8" data-id="element-988" data-mp="1wdhfo8ew23e9">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-989" data-mp="21bsocftg67uw">
                  {/* Nom */}
                  <div className="space-y-2" data-id="element-990" data-mp="25ficx5a4gpfx">
                    <label className="text-sm font-medium text-gray-700" data-id="element-991" data-mp="25cmd1beprqou">
                      Nom *
                    </label>
                    <input type="text" name="nom" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1E88E5] focus:border-transparent outline-none transition-all" placeholder="Votre nom" data-id="element-992" data-mp="1dnsxzh01sjgu" />
                  </div>

                  {/* Prénom */}
                  <div className="space-y-2" data-id="element-993" data-mp="ty8veoak07h9">
                    <label className="text-sm font-medium text-gray-700" data-id="element-994" data-mp="txfsjyepu24e">
                      Prénom *
                    </label>
                    <input type="text" name="prenom" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1E88E5] focus:border-transparent outline-none transition-all" placeholder="Votre prénom" data-id="element-995" data-mp="228r772b6qpru" />
                  </div>

                  {/* Email */}
                  <div className="space-y-2" data-id="element-996" data-mp="1jb7thlds8iz3">
                    <label className="text-sm font-medium text-gray-700" data-id="element-997" data-mp="1ebbphm534rjj">
                      Email *
                    </label>
                    <input type="email" name="email" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1E88E5] focus:border-transparent outline-none transition-all" placeholder="votre@email.com" data-id="element-998" data-mp="1sbcxdljroz8i" />
                  </div>

                  {/* Téléphone */}
                  <div className="space-y-2" data-id="element-999" data-mp="376w36ljypy6o">
                    <label className="text-sm font-medium text-gray-700" data-id="element-1000" data-mp="3baakrgnjumm8">
                      Téléphone *
                    </label>
                    <input type="tel" name="telephone" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1E88E5] focus:border-transparent outline-none transition-all" placeholder="+229..." data-id="element-1001" data-mp="2xbb5v0pu9m39" />
                  </div>

                  {/* Domaine d'expertise */}
                  <div className="space-y-2 md:col-span-2" data-id="element-1002" data-mp="3g719sthc0sjs">
                    <label className="text-sm font-medium text-gray-700" data-id="element-1003" data-mp="3l6nn12x5u8sl">
                      Domaine d'expertise principal *
                    </label>
                    <select name="domaine" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1E88E5] focus:border-transparent outline-none transition-all bg-white" data-id="element-1004" data-mp="hilrmj37uaua">
                      <option value="" data-id="element-1005" data-mp="2g1icut6uvayr">Sélectionnez votre domaine...</option>
                      <option value="hotellerie" data-id="element-1006" data-mp="2g3lds89jqoi9">
                        Hôtellerie / Restauration
                      </option>
                      <option value="nettoyage" data-id="element-1007" data-mp="38qxonl6ch7vq">Nettoyage / Hygiène</option>
                      <option value="care" data-id="element-1008" data-mp="33rcox8jcovhy">
                        Services à la personne / Nounou
                      </option>
                      <option value="autre" data-id="element-1009" data-mp="2yzuocll8owxi">Autre</option>
                    </select>
                  </div>

                  {/* Expérience */}
                  <div className="space-y-2" data-id="element-1010" data-mp="2tzfc5xcp1vh4">
                    <label className="text-sm font-medium text-gray-700" data-id="element-1011" data-mp="3rh71dozrci1o">
                      Années d'expérience *
                    </label>
                    <select name="experience" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1E88E5] focus:border-transparent outline-none transition-all bg-white" data-id="element-1012" data-mp="3movz4fhjok5y">
                      <option value="" data-id="element-1013" data-mp="7w84skj9jzaz">Sélectionnez...</option>
                      <option value="1-3" data-id="element-1014" data-mp="cu9kqwle7ii8">1 à 3 ans</option>
                      <option value="3-5" data-id="element-1015" data-mp="gutmyektpcb8">3 à 5 ans</option>
                      <option value="5-10" data-id="element-1016" data-mp="guaahddxzg4l">5 à 10 ans</option>
                      <option value="10+" data-id="element-1017" data-mp="lt4uginnbaqa">Plus de 10 ans</option>
                    </select>
                  </div>

                  {/* Disponibilité */}
                  <div className="space-y-2" data-id="element-1018" data-mp="qmza9b04r5k3">
                    <label className="text-sm font-medium text-gray-700" data-id="element-1019" data-mp="vjzjtvw6uqfy">
                      Disponibilité *
                    </label>
                    <select name="disponibilite" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1E88E5] focus:border-transparent outline-none transition-all bg-white" data-id="element-1020" data-mp="10kneqsnjfrfg">
                      <option value="" data-id="element-1021" data-mp="2wjuo7pzt3m76">Vos disponibilités ?</option>
                      <option value="ponctuelle" data-id="element-1022" data-mp="3ae5ewcvd5qfv">
                        Ponctuelle (quelques jours/mois)
                      </option>
                      <option value="weekends" data-id="element-1023" data-mp="35ksqo3uljlnn">Week-ends uniquement</option>
                      <option value="flexible" data-id="element-1024" data-mp="3k9oxxyotwun7">Flexible</option>
                    </select>
                  </div>

                  {/* CV / Lien LinkedIn */}
                  <div className="space-y-2 md:col-span-2" data-id="element-1025" data-mp="3tchq045u5ae3">
                    <label className="text-sm font-medium text-gray-700" data-id="element-1026" data-mp="3t9vig4iy2uvv">
                      CV (Lien ou description de votre parcours) *
                    </label>
                    <textarea name="cv" required rows={4} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1E88E5] focus:border-transparent outline-none transition-all" placeholder="Lien vers votre profil LinkedIn, ou décrivez brièvement votre parcours professionnel..." data-id="element-1027" data-mp="1yyp4fcablupq"></textarea>
                  </div>
                </div>

                <div className="bg-amber-50 border border-amber-200 rounded-lg p-4" data-id="element-1028" data-mp="1g0dk7d3jmr7c">
                  <p className="text-xs text-gray-600 leading-relaxed" data-id="element-1029" data-mp="113wasrewzmnf">
                    <span className="font-semibold text-gray-800" data-id="element-1030" data-mp="164a9vjyjfm9b">
                      📷 Droit à l'image :
                    </span>{' '}
                    En participant aux activités ADCC (formations, ateliers,
                    foires, événements ou toute autre activité), vous autorisez
                    ADCC à utiliser votre image (photos et vidéos) réalisées
                    lors de ces activités à des fins de communication
                    institutionnelle et promotionnelle sur le site adcc.africa
                    et les supports numériques et imprimés associés. Cette
                    autorisation peut être retirée à tout moment par demande
                    écrite adressée à ADCC, sans effet rétroactif sur les
                    contenus déjà publiés.
                  </p>
                </div>

                <Button type="submit" className="w-full text-lg py-6 shadow-lg" disabled={isLoading} data-id="element-1031" data-mp="3m9mh0pdu7dtg">
                  {isLoading ? 'Envoi en cours...' : 'Envoyer ma candidature'}
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </section>
    </Layout>;
}